import React from 'react';
import PropTypes from 'prop-types';
import { v4 as uuidv4 } from 'uuid';
import moment from 'moment';
import UserMessage from '../UserMessage/UserMessage';
import DefaultAvatarImg from '../../../assets/svg/avatar-default.svg';
import InstructionsText from '../InstructionsText/InstructionsText';

export const isMobile = () => window.innerWidth <= 780;

function ChatMessages({ messages, isActive, onOpenModalUsers }) {
  const getParsedMessages = () => {
    const messagesSort = messages.sort((a, b) => moment(a.createdAt) > moment(b.createdAt));
    return messagesSort.map((item) => ({
      id: item.messageId,
      avatar: DefaultAvatarImg,
      content: item.content,
      date: moment(item.createdAt).format('lll'),
      owner: item.owner,
    }));
  };

  return (
    <div className="chat-area-main">
      {isActive ? (
        getParsedMessages().map((item) => <UserMessage key={uuidv4()} message={item} />)
      ) : (
        <InstructionsText />
      )}
    </div>
  );
}

ChatMessages.defaultProps = {
  isActive: null,
};

ChatMessages.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  isActive: PropTypes.any,
  onOpenModalUsers: PropTypes.func.isRequired,
  messages: PropTypes.arrayOf(
    PropTypes.shape({
      content: PropTypes.string.isRequired,
    }),
  ).isRequired,
};

export default ChatMessages;
